var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"target":"_blank","href":_vm.link}},[_c('i',{staticClass:"pi pi-book"})])
}
var staticRenderFns = []

export { render, staticRenderFns }